import { getDeliverySolutions } from '@wix/ambassador-gateways-ecom-v1-delivery-rates-gateway/http';
import { DEFAULT_LANG } from '../consts';
export const getDeliveryOptions = async (httpClient, withErrorHandler, params) => {
  const currencyHeader = params.currency ? {
    'x-wix-currency': params.currency
  } : {};
  const request = getDeliverySolutions(params);
  const response = await withErrorHandler(() => httpClient.request(args => ({
    ...request(args),
    headers: currencyHeader
  })), {
    errorCodesMap: {}
  });
  return response.data;
};
export const getTotalPrice = option => {
  var _option$cost, _option$cost2;
  const baseCost = Number((_option$cost = option.cost) == null || (_option$cost = _option$cost.deliveryPrice) == null ? void 0 : _option$cost.convertedAmount) || 0;
  const totalAdditionalCosts = ((_option$cost2 = option.cost) == null || (_option$cost2 = _option$cost2.additionalCosts) == null ? void 0 : _option$cost2.reduce((acc, fee) => {
    var _fee$deliveryPrice;
    return acc + (Number(fee == null || (_fee$deliveryPrice = fee.deliveryPrice) == null ? void 0 : _fee$deliveryPrice.convertedAmount) || 0);
  }, 0)) || 0;
  return baseCost + totalAdditionalCosts;
};
export const getLocale = controllerConfig => {
  return getMLLocale(controllerConfig) || controllerConfig.wixCodeApi.site.regionalSettings || DEFAULT_LANG;
};
const getMLLocale = controllerConfig => {
  const currentLang = getCurrentlyUsedMultilingualLanguage(controllerConfig);
  if (!currentLang) {
    return undefined;
  }
  return currentLang.locale || controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
};
const getCurrentlyUsedMultilingualLanguage = controllerConfig => {
  const currentShortLang = controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
  return controllerConfig.wixCodeApi.window.multilingual.siteLanguages.find(lang => lang.languageCode === currentShortLang);
};
//# sourceMappingURL=deliveryOptionsUtils.js.map